import { serverUrl } from '../config';

type ServerStatus = 'ok' | 'error';
type GetPasswordResetError = 'user-does-not-exist' | 'rate-limit' | 'failure';

export const getPasswordResetErrorMessage = (error: GetPasswordResetError) => {
  switch (error) {
    case 'user-does-not-exist':
      return 'No user found with that email address';
    case 'rate-limit':
      return 'Please wait a few minutes and check your inbox for a reset.';
    case 'failure':
      return 'Something went wrong. Please try again in a few minutes.';
  }
};

type GetPasswordResetResponse = { status: ServerStatus; error?: GetPasswordResetError };

export const getPasswordReset = (body: { email: string }): Promise<GetPasswordResetResponse> =>
  fetch(`${serverUrl}/api/actions/forgot-password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  }).then((res) => res.json());

type PostPasswordResetError = 'invalid' | 'update-error';

export const postPasswordResetErrorMessage = (error: PostPasswordResetError) => {
  switch (error) {
    case 'invalid':
      return 'This password reset url is expired or invalid. Sorry.';
    default:
      return 'Something went wrong. Please try again in a few minutes.';
  }
};

type ResetPasswordResponse = {
  status: ServerStatus;
  error?: PostPasswordResetError;
};

export const postPasswordReset = (
  oneTimeToken: string,
  newPassword: string
): Promise<ResetPasswordResponse> => {
  console.log({ token: oneTimeToken, newPassword });

  return fetch(`${serverUrl}/api/actions/reset-password`, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ token: oneTimeToken, newPassword }),
  }).then((res) => res.json());
};
